// extracted by mini-css-extract-plugin
export default {"container":"Divider_container__vlCk0","horizontal":"Divider_horizontal__Vm28v","vertical":"Divider_vertical__k0XhP"};